import React, { PropTypes } from 'react';
import { createDragPreview } from 'react-dnd-text-dragpreview';
import { DragSource } from 'react-dnd';
import _ from 'lodash';

import { OrdersExpander } from './OrdersExpander';
import { Order } from './order/Order';
import { ItemTypes } from '../../constants/actionTypes';
//import { DragDropContext } from 'react-dnd'

export default class OrdersGroup extends React.Component {

  renderContent() {
    const { isOpen, orders, toggle, title, recipients, pickUpPoints, drivers, users, vehicles, router, orderType } = this.props;
    
    return (
      <OrdersExpander isOpen={isOpen} orders={orders} toggle={toggle} title={title} orderHeight={87}>
        {orders.map(order => this.renderOrder(order, recipients, pickUpPoints, drivers, users, vehicles, router, orderType))}
      </OrdersExpander>
    );
  }

  renderOrder(order, recipients, pickUpPoints, drivers, users, vehicles, router, orderType) {
    let isSelected = _.some(this.props.ordersSelectedOnTable, order);

    return (<Order
      orderType={orderType}
      order={order}
      key={order.id}
      isSelected={isSelected}
      startDraggingOrder={this.props.startDraggingOrder}
      pickUpPoints={pickUpPoints}
      recipients={recipients}
      drivers={drivers}
      showMessage={this.props.showMessage}
      orderClick={this.props.orderClick}
      handleOrderSelectChange={this.props.handleOrderSelectChange}
      selectedOrders={this.props.ordersSelectedOnTable}
      clearSelectedOrders={this.props.clearSelectedOrders}
      users={users}
      vehicles={vehicles}
      router={router}
      appActions = {this.props.appActions}
      cancelOrder={this.props.dashboardPageActions.cancelOrder}
      renderModalForDetails={this.props.renderModalForDetails}
      orders={this.props.orders}
      originalOrders={this.props.originalOrders}/>);
  }

  render() { 
    return this.renderContent();
  }
}

OrdersGroup.propTypes = {
  title: PropTypes.string,
  orders: PropTypes.array,
  recipients: PropTypes.array,
  pickUpPoints: PropTypes.object,
  drivers: PropTypes.array,
  users: PropTypes.array,
  vehicles: PropTypes.array,
  appActions: PropTypes.object
};

// export default DragSource(ItemTypes.ORDER, orderSource, collect)(OrdersGroup);



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/OrdersGroup.js